import Vue from 'vue';
import Vuex from 'vuex';

export const ENROLMENT_RESPONSE_NAMESPACE = 'enrolmentResponse';
export const SURVEY_RESPONSE_NAMESPACE = 'surveyResponse';


Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
    },
    strict: debug
})